module.exports = __webpack_public_path__ + "static/emureset-725adcc6ca5fa994984e5bbb93443d23.png";